<template>
  <div>
    <div class="product-wrapper section-gap pb-0 mt-3">
      <div class="card container">
        <!-- top section -->
        <div class="row mb-1">
          <!-- cover image -->
          <div class="col-sm-12 col-md-12 col-lg-6 product-detail-content mt-5" style="height: 100%">
            <div class="mb-4">
              <div class="feature-box-thumb">
                <img v-if="ListOfData.ImageURL" :src="baseURL + ListOfData.ImageURL" class="img-fluid card-shadow"
                  height="100%" width="100%" alt="product image" />
                <img v-else src="/static/img/enNotAvail.png" alt="" height="100%" class="card-img-top border-bottom" />
              </div>
              <!-- feature box thumb closed -->
            </div>
          </div>
          <!-- icon Favorite -->
          <span style="background-color: red" class="_addtoFav py-2 px-3 position-absolute m-3"
            @click.stop="UpdateStatus(ListOfData)">
            <i class="fa fa-heart text-white fa-2x" v-if="ListOfData.IsFavorite"></i>
            <i class="far fa-heart text-white fa-2x" v-else></i>
          </span>
          <!-- details Book Info -->
          <div class="col-sm-12 col-md-12 col-lg-6 product-detail-content mt-5" style="height: 100%">
            <div class="card col-sm-12 col-md-12 col-lg-12 mb-3">
              <!-- Book Name -->
              <vx-tooltip :title="$t('ClickHereToShowBrief')" style="
                                background-color: #f78500;
                                border-radius: 8px;
                                position: relative;
                                width: 100%;
                              " class="mb-2">
                <h1 @click="GotoBrief(ListOfData.ID)" class="p-2 font-weight-bold font-3x" style="color: #f2f2f2">
                  {{ ListOfData.Name }}
                </h1>
              </vx-tooltip>
              <div v-if="ListOfData.AuthorName">
                {{ $t("AuthorName") }} : {{ ListOfData.AuthorName }}
              </div>
              <div v-if="ListOfData.PublishHouse">
                {{ $t("publishedby") }} : {{ ListOfData.PublishHouse }}
              </div>
              <!-- <div v-if="ListOfData.PublishHouse" class=" ">
                {{ ListOfData.PublishHouse }}
              </div> -->
              <div v-if="ListOfData.CreatedDate">
                {{ $t("publishedDate") }} :
                {{ ListOfData.CreatedDate | formatDate("yyyy/MM/dd") }}
              </div>
              <div class="" v-if="ListOfData.MediaTypeID == 4 && ListOfData.NumberOfPages">
                {{ $t("NumberOfPages") }} : {{ ListOfData.NumberOfPages }}
              </div>
              <div class="m-0" v-if="ListOfData.DepositNumber">
                {{ $t("DepositNumber") }} : {{ ListOfData.DepositNumber }}
              </div>

              <!-- <p class=" ">
                {{ ListOfData.Brief }}
              </p> -->

              <!-- ReadNow -->
              <div class="m-2">
                <!-- URL: "/Uploads/sample.pdf" -->
                <!-- MediaTypeID: 4 -->
                <p v-if="ListOfData.URL" class="btn btn-primary rounded-pill text-white btn-lg"
                  @click="openBook(ListOfData.URL)">
                  {{ $t("ReadNow") }}
                </p>
                <!-- <a
                :href="baseURL + ListOfData.URL"
                target="_blank"
                class="btn btn-primary rounded-pill text-white btn-lg"
                >{{ $t("ReadNow") }}</a
              > -->
                <span v-if="ListOfData.DownloadURL" class="_addtoFav py-2 px-3 position-absolute" @click="DownloadFile">
                  <a :href="ListOfData.DownloadURL" class="mr-3">
                    <i class="fa fa-download fas"></i>
                  </a>
                </span>
              </div>
              <!-- share icon -->
              <div class="m-3" style="height: 30%; text-align: center">
                <router-link :to="{
                  name: 'BookDetailsBrief',
                  params: { ID: ListOfData.ID },
                }">
                  <button class="
                                    rounded-pill
                                    ml-2
                                    mr-2
                                    text-white
                                    btn btn-primary
                                    pl-3
                                    pr-3
                                  ">
                    {{ $t("ContinueBrief") }}
                  </button>
                </router-link>
                <facebook :url="baseURL + ListOfData.URL" scale="3" class="mt-4"></facebook>
                <whats-app :url="baseURL + ListOfData.URL" class="ml-2 pr-2" title="Hello" scale="3"></whats-app>
                <router-link :to="{
                  name: 'Complain',
                  params: { ID: ListOfData.ID },
                }">
                  <button class="
                                    rounded-pill
                                    ml-2
                                    mr-2
                                    text-white
                                    btn btn-primary
                                    pl-3
                                    pr-3
                                  ">
                    {{ $t("Complain") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- index -->
        <div class="row" style="text-align:center ; vertical-align:middle; display: flex; align-items: center;
         justify-content: center" align="center">
         


            <div class="col
                            tab-style
                            pl-3
                            pt-0
                            col-sm-12 col-md-12 col-lg-6
                            justify-content-between justify-center
                            align-center
                          " style="text-align: center" align="center">
              <h4 class="font-weight-bold mb-2">
                {{ $t("Tableofcontents") }}
              </h4>
              <!-- Tableofcontents -->
              <div class="table-responsive m-2">
                <table class="table table-bordered mt-2" border="primary">
                  <thead>
                    <tr class="table-warning">
                      <th class="w-20 text-center position-relative">
                        {{ $t("Subject") }}
                      </th>
                      <th class="w-20 text-center">{{ $t("PageNumberBook") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tr, index) of ListOfData.LibraryIndexes" :key="index" class="table-info">
                      <td class="w-20 text-center position-relative">
                        {{ tr.Name }}
                      </td>
                      <td class="w-20 text-center">
                        {{ tr.PageNumber }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <p class=" mb-3">{{ ListOfData.BookIndex }}</p> -->
              <!-- <h6 class=" ">
          {{ ListOfData.Brief }}
        </h6> -->
            </div>
         
        </div>
      </div>

      <!-- <div class="tab-style section-gap pt-0">
        <div class="container">
          <ul class="nav nav-tabs nav-tabs-bottom mb-4">
            <li class="nav-item" aria-expanded="false">
              <a
                class="nav-link active"
                aria-expanded="true"
                data-toggle="tab"
                href="#tab-1"
                >Description</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                aria-expanded="false"
                data-toggle="tab"
                href="#tab-2"
                >Specification</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                aria-expanded="false"
                data-toggle="tab"
                href="#tab-3"
                >Reviews</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div
              class="tab-pane fade active show"
              id="tab-1"
              aria-expanded="true"
            >
              <p>
                Super charge your walk! Easy portable effortless light weight!
                Swing Weights were designed to be the best, most effective
                walking weight on the market.Use Swing Weights as you walk for a
                low-impact, fully body workout.
              </p>
              <p class="mb-0">
                The dumbbell material : outside is rubber,inside is cast iron .
                the weigth is enough .5kg is 5kg ,10kg is 10kg .we also can make
                client's logo on the cover.
              </p>
            </div>
            <div class="tab-pane fade" id="tab-2" aria-expanded="false">
              <p class="mb-0">
                - Silver, space silver, 1.48 inch TFT LCD capacitive touch
                screen, 128*128 pixels Resolution; Dial- Plastic; Strap-
                Flexible &amp; durable - Bluetooth 4.0, Magnetic charging cable
                (2 m), Sport Band - Retina display with Force Touch, Sport Band
                with stainless steel pin, Composite back, accelerometer
              </p>
            </div>
            <div class="tab-pane fade" id="tab-3" aria-expanded="false">
              <p class="mb-0">
                If you are willing to buy this watch then just order it right
                away without any second thought. This is a watch with great
                tools on it. So the internals had to be pretty good. It is a
                watch worth every penny. I used it on a daily basis for a pretty
                long time and it didn't lag even once and still works like
                charm.
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- tab-style closed -->
    </div>
    <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="Downloaded">
      <strong>{{ $t("Success") }}</strong>
      {{ $t("FileDownloadedSuccessfuly") }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="col-sm-12 col-md-6 mx-auto m-3" style="text-align: center">
      <button @click="back" type="border" class="
                        btn btn-primary
                        rounded-pill
                        text-white
                        btn-lg
                        rounded-pill
                        pl-4
                        pr-4
                        pb-2
                        font-1x
                      ">
        {{ $t("back") }}
      </button>
    </div>
  </div>
</template>
<script>
import { domain } from "@/globalComponents.js";

import RelatedProducts from "Components/Sections/RelatedProducts.vue";
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";
import { Facebook, WhatsApp } from "vue-socialmedia-share";
export default {
  components: {
    RelatedProducts,
  },
  data() {
    return {
      ListOfData: {},
      model: {},
      baseURL: domain,
      Downloaded: false,
      // videoContent,
    };
  },
  components: {
    Facebook,

    WhatsApp,
  },
  methods: {
    GotoBrief(ID) {
      this.$router.push({ name: "BookDetailsBrief", params: { ID: ID } });
    },
    openBook(bookUrl) {
      debugger;
      window.open(bookUrl, "_blank");
      // window.open(this.baseURL + bookUrl, "_blank");
    },
    back() {
      this.$router.go(-1);
    },
    UpdateStatus(item) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.libraryID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            this.ListOfData.IsFavorite = !this.ListOfData.IsFavorite;
          })
          .catch(() => { });
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    DownloadFile() {
      // var link = this.baseURL + this.ListOfData.URL;

      var link = this.ListOfData.DownloadURL;
      debugger;
      // link.download = this.ListOfData.URL;
      // link.href = this.baseURL;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // debugger;
      // fetch(link).then((t) => {
      //   debugger;
      //   t;
      //   debugger;
      //   return t.blob().then((b) => {
      //     var a = document.createElement("a");
      //     a.href = URL.createObjectURL(b);
      //     debugger;
      //     a.setAttribute("download", this.ListOfData.DownloadURL);
      //     a.click();
      //     this.Downloaded = true;
      //   });
      // });
      var a = document.createElement("a");
      a.setAttribute("download", this.ListOfData.DownloadURL);
      a.click();
    },
  },
  created() {
    debugger;
    if (!modulePageDetails.isRegistered) {
      debugger
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
    let ID = this.$route.params.ID;

    this.$store
      .dispatch("DetailsList/GetLibrary", ID)
      .then((response) => {
        if (response.status == 200) {
          //   alert("ٍ" + this.model.pageNumber);
          this.ListOfData = response.data.data;
          this.isMounted = true;
        }
      })
      .catch(() => { });
  },
};
</script>


<style>
@media (min-width: 320px) and (max-width: 1200px) {
  .headerBook {
    width: 108%;
    position: relative;
    left: 15px;
  }
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .headerBook {
    width: 1030%;
    left: 20px;
  }
}
</style>
